import { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';

export function useVariance(month, year) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchData = () => {
    setLoading(true);
    setError(null);
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year)  params.append('year', year);
    authFetch(`/api/variance?${params.toString()}`)
      .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
      .then(d  => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  };

  useEffect(() => { fetchData(); }, [month, year]);

  return { data, loading, error, refresh: fetchData };
}